<template>
	<div>
		<el-card class="box-card" label="包裹信息" shadow="hover" v-for="(item, index) in pageset" :key="index">
			<div slot="header" class="clearfix">
				<span>包裹信息-{{ index+1 }}</span>
			</div>
			<div v-for="(i, idx) in item.setlist" style="margin-top:-30px">
				<div v-if="i.controltype == 'table'">
					<tableui
						ref="cargo"
						editcell="1"
						:tableData="i.cargolist"
						:columns="columns"
						@gridhandle="val => gridhandle(val, i, idx)"
						@autoaddrow="val => gridhandle(val, i, idx)"
						:gridheight="cargogridheight"
					></tableui>
				</div>
				<el-col :span="12">
					<el-form-item
						:label="i.showname"
						label-width="130px"
						size="mini"
						v-if="
							i.controltype != 'table' &&
								i.ishidden == 'False'
						"
					>
						<div v-if="(i.controltype == 'text' || i.controltype == 'textarea')&&!isdetail">
							<el-input
								:ref="i.colname"
								v-model="i.value"
								type="i.controltype"
								:style="{ width: `${i.coltdwidth}px` }"
								@keyup.native="val => enterinput(val, i)"
							></el-input>
							<span class="input_tips">{{ i.colass }}</span>
						</div>
						<span v-if="(i.controltype == 'text' || i.controltype == 'textarea')&&isdetail">{{i.value}}</span>
						<el-select v-model="i.value" v-if="i.controltype == 'select' && i.ishidden == 'False'&&!isdetail" :style="{ width: `${i.coltdwidth}px` }">
							<el-option v-for="(opt, opti) in i.colsource" :key="opti" :value="opt.title">{{ opt.title }}</el-option>
						</el-select>
						<span v-if="(i.controltype == 'select'&& i.ishidden == 'False')&&isdetail">{{i.value}}</span>
						<label v-if="i.controltype == 'checkbox' && i.ishidden == 'False'">
							<el-checkbox
								:style="{ width: i.isEnable != undefined || i.isEnable != null ? `200px` : '' }"
								v-model="i.value"
								:true-label="1"
								:false-label="0"
								:checked="i.value == '1' ? true : false"
							></el-checkbox>
						</label>
						<div v-if="i.controltype == 'combox-checkbox_notips' && i.ishidden == 'False'">
							<el-checkbox
								:style="{ width: i.isEnable != undefined || i.isEnable != null ? `200px` : '' }"
								true-label="1"
								false-label="0"
								:ref="i.colname + '_checked'"
								:checked="i.value != '' && i.value != '0.00' ? true : false"
								@change="val => checkchange(val, i.colname, i)"
							></el-checkbox>
							<el-input
								:style="{
									width: `${i.coltdwidth}px`,
									marginLeft: `10px`,
									display: `${i.value != '' && i.value != '0.00' ? 'inline-block' : 'none'}`
								}"
								:ref="i.colname"
								type="text"
								v-model="i.value"
								@keyup.native="val => enterinput(val, i)"
								v-if="!isdetail"
							></el-input>
							<span v-if="isdetail">{{i.value}}</span>
						</div>
						<div v-if="i.controltype == 'combox-checkbox' && i.ishidden == 'False'">
							<el-checkbox
								:style="{ width: i.isEnable != undefined || i.isEnable != null ? `200px` : '' }"
								true-label="1"
								false-label="0"
								:checked="i.value != '' && i.value != '0.00' ? true : false"
								@change="val => checkchange(val, i.colname + '_' + idx, i)"
							></el-checkbox>
							<el-input
								:style="{
									width: `${i.coltdwidth}px`,
									marginLeft: `10px`,
									display: `${i.value != '' && i.value != '0.00' ? 'inline-block' : 'none'}`
								}"
								:ref="i.colname + '_' + idx"
								type="text"
								v-model="i.value"
								@keyup.native="val => enterinput(val, i)"
							 v-if="!isdetail"
							></el-input>
							<span v-if="isdetail">{{i.value}}</span>
						</div>
						<div v-if="i.controltype=='checkbox_radio_link'&&!isdetail">
							<el-checkbox
								:style="{ width: i.isEnable != undefined || i.isEnable != null ? `200px` : '',marginRight:'30px' }"
								:ref="i.colname + '_checked'"
								true-label="1"
								false-label="0"
								@change="val => checkchange(val, i.colname, i)"
							></el-checkbox>
							 <el-radio-group v-model="i.value" :ref="i.colname" :style="{marginLeft: `10px`,display:`none`}">
							    <el-radio v-for="(source, idx) in i.colsource" :key="idx" :label="source.title">{{source.title}}</el-radio>
							 </el-radio-group>
						</div>
						<div v-if="i.controltype=='combox-input'" class="tiji">
							<span v-for="(tj, ti) in i.combox" :key="ti">
								{{ tj.showname }}
								<el-input style="width:50px;margin-right:10px" v-model="tj.value" v-if="!isdetail"></el-input>
								<span v-if="isdetail">{{tj.value}}</span>
							</span>
						</div>
						<div  v-if="i.controltype == 'addedservice_sign-insured'">
							<div v-for="(it,itx) in i.addedservice" :key="itx">
								<div v-if="it.d_name == '保价'">
									<el-checkbox
										style="width:80px"
										:ref="it.d_name + '_' + index + '_checked'"
										:checked="it.ischecked"
										v-model="it.ischecked"
										@change="val => checkchange(val, it.d_name + '_' + index, i,index)"
									>
										{{ it.label }}
									</el-checkbox>
									<el-input
										:style="{
											width: `90px`,
											marginLeft: `10px`,
											display: `${it.ischecked? 'inline-block' : 'none'}`
										}"
										:ref="it.d_name + '_' + index"
										type="text"
										v-model="it.factprice"
										@keyup.native="val => enterinput(val, i)"
										v-if="!isdetail"
									></el-input>
									<span style="margin-left:50px" v-if="isdetail&&it.ischecked">{{it.factprice}}</span>
								</div>
								<label v-else>
									<el-checkbox style="width:200px" v-model="it.ischecked" :checked="it.ischecked">{{ it.label }}</el-checkbox>
								</label>
							</div>
						</div>
					</el-form-item>
				</el-col>
			</div>
			<el-col :span="24" style="padding-bottom:5px;" v-if="!isdetail">
				<el-button type="primary" size="mini" style="margin-left:10px" @click="addpackage(item, index)" v-if="index>=0">添加包裹</el-button>
				<el-button size="mini" type="warning" style="margin-left:10px" @click="removepackage(index)" v-if="index > 0||index+1<pageset.length">
					移除包裹
				</el-button>
			</el-col>
		</el-card>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
import tableui from '@/components/table/tablegrid.vue';
export default {
	components: {
		tableui
	},
	props: {
		title: {
			type: String,
			default: ''
		},
		l_mode: {
			type: String,
			default: ''
		},
		gridheight: {
			type: String,
			default: '100px'
		}
	},
	data() {
		return {
			//packageindex: 0,
			//orderempty:[{ index: 1,p_pkval:'',cargolist:[],baginfo:{packageweight:1,}}],
			orderinfo: {},
			pageset: [],
			setlist: [],
			columns: [],
			cargorow: {},
			gridrowindex: 0,
			handle: {
				field: '',
				title: '操作',
				type: 'template',
				template: [
					{ type: 'link', title: '添加', icon: '', handletype: 'success', event: 'addrow' },
					{ type: 'link', title: '删除', icon: '', handletype: 'danger', event: 'delrow' }
				],
				width: 120,
				sortable: false,
				evttype: 'click',
				colshow: '1',
				event: ''
			},
			iscopy:0,
			isdetail:false,
			addedservice:[],
			l_mode_cargo:'',
			cargogridheight:'100px'
		};
	},
	mounted() {
		this.cargogridheight=this.gridheight;
	},
	methods: {
		init(param) {
			
			var that = this;
			if (param.syscol != undefined) {
				this.syscol = param.syscol;
			}
			if (param.iscopy != undefined) this.iscopy = param.iscopy;
			if (param.orderinfo != undefined) this.orderinfo = param.orderinfo;
			if(param.isdetail!=undefined){
				this.isdetail=param.isdetail;
				if(this.isdetail)
					this.cargogridheight='300px';
			}
			if(param.l_mode_cargo!=undefined)
				this.l_mode_cargo=param.l_mode_cargo;
			this.setlist = [];
			this.getsetlist();
		},
		getsetlist() {
			var that = this;
			this.$apipost.get.GetPagecolSet({ syscol: this.syscol, l_mode: this.l_mode }).then(res => {
				//debugger
				if (res.length > 0) {
					res.forEach(e=>{
						if(e.colname=='addedservice'){
							//debugger
							if(e.colformat!=''&&e.colformat!=undefined){
								e.addedservice=JSON.parse(JSON.stringify(e.colformat));
								that.addedservice=JSON.parse(JSON.stringify(e.colformat));
							}
							return false;
						}	
					});
					that.setlist = res;
				}
				that.getcargosetlist();
			});
		},
		enterinput(event, i, enterinput) {
			if (event.keyCode != undefined) {
				if (event.keyCode == 13 || event.keyCode == 39) {
					if (i.colnext != '') {
						if (i.colnext == 'tablegrid') this.$refs.cargo[0].setgridfoucs();
						else this.$refs[i.colnext][0].focus();
					}
				} else if (event.keyCode == 37) {
					if (i.colperv != '') this.$refs[i.colperv][0].focus();
				}
			}
		},
		checkchange(val, control, i) {
			if (val == '1') {
				this.$refs[control][0].$el.style.display = 'inline-block';
				if (this.$refs[control + '_span'] != undefined) {
					this.$refs[control + '_span'][0].style.display = 'inline-block';
				}
			} else {
				if (i != undefined) i.value = '';
				this.$refs[control][0].$el.style.display = 'none';
				if (this.$refs[control + '_span'] != undefined) {
					this.$refs[control + '_span'][0].style.display = 'none';
				}
			}
		},
		setcheck(val, i) {
			if (val) i.value = 1;
			else i.value = 0;
		},
		//添加包裹
		addpackage(item, index) {
			//debugger
			var that = this;
			this.pageset.push(JSON.parse(JSON.stringify(item)));
			var modeitem = this.pageset[parseInt(index) + 1]; //JSON.parse(JSON.stringify(item));
			modeitem.setlist.forEach(e => {
				//debugger;
				if (e.controltype == 'table') {
					if (e.cargolist != undefined) {
						e.cargolist = [];
						e.cargolist.splice(1, 0, JSON.parse(JSON.stringify(that.cargorow)));
					}
				} else {
					if (e.combox != undefined) {
						e.combox.forEach(com => {
							com.value = '';
						});
					} else {
						if (e.coldefault != '') e.value = e.coldefault;
						else e.value = '';
					}
				}
			});
			this.$emit('formScrollTop');
		},
		//移除包裹
		removepackage(index) {
			this.pageset.splice(index, 1);
		},
		//包裹列表的信息
		getcargosetlist() {
			//debugger
			var that = this;
			var l_mode=this.l_mode_cargo!=''?this.l_mode_cargo:'包裹信息列表-出口';
			this.$apipost.get.GetPagecolSet({ syscol: this.syscol, l_mode:l_mode}).then(res => {
				//debugger
				if (res.length > 0) {
					that.setlist.splice(0, 0, res[0]);
					var columns= JSON.parse(JSON.stringify(res[0].table));
					if(!that.isdetail){
						that.handle.index = that.columns.length + 1;
						columns.push(that.handle);
					}else{
						columns.forEach(e=>{
							e.type='text';
						});
					}
					that.columns = columns;
					that.setcargocol(res[0].table);
					//debugger
					that.setpagelayout();
				}
			});
		},
		//生成默认行
		setcargocol(colset) {
			var cargo = '';
			colset.forEach(e => {
				if (e.type != 'template') {
					cargo += '"' + e.field + '":"",';
				}
			});
			if (cargo != '') {
				cargo = cargo.substring(0, cargo.length - 1);
			}
			cargo = '[{' + cargo + '}]';
			this.cargorow = JSON.parse(cargo)[0];
		},
		//设置页面数据
		setpagelayout() {
			var that = this;
			this.pageset = [];
			this.pageset.push({ setlist: JSON.parse(JSON.stringify(this.setlist)) });
			if (this.orderinfo.list==undefined) {
				this.pageset.forEach(e => {
					e.setlist.forEach(s => {
						if (s.controltype == 'table') {
							s.cargolist = [];
							s.cargolist.splice(0, 0, JSON.parse(JSON.stringify(that.cargorow)));
						}
					});
				});
			}else{
				var index=0;
				//包裹列表
				this.orderinfo.list.forEach(e=>{
					if(index>0)
						that.pageset.push({ setlist: JSON.parse(JSON.stringify(that.setlist)) });
					that.pageset[index].setlist.forEach(s => {
						if (s.controltype == 'table') {
							s.cargolist = e.cargolist;
						}else{
							if(e.baginfo!=undefined){
								for(var b in e.baginfo){
									if(s.controltype == 'combox-input'){
										var volume = s.combox;
										volume.forEach(v=>{
											if(v.colname==b){
												v.value=e.baginfo[b];
												return false;
											}
										});
									}
									else {
										if (s.colname == b) {
											if(s.colname=='addedservice'){
												s.addedservice=JSON.parse(e.baginfo.addedservice);
											}else{
												s.value = e.baginfo[b];
											}
											return false;
										}
									}
							    }
						   }
						}
					});
					index++;
				});
			}
		},
		//列表操作列
		gridhandle(e, i, index) {
			var that = this;
			if (e.event == 'addrow') {
				i.cargolist.splice(e.index + 1, 0, JSON.parse(JSON.stringify(this.cargorow)));
			}
			if (e.event == 'delrow') {
				this.deleteRow(e, i, index);
			}
		},
		//删除行
		deleteRow(e, i, index) {
			i.cargolist.splice(e.index, 1);
			if (i.cargolist.length < 1) {
				i.cargolist.push(JSON.parse(JSON.stringify(this.cargorow)));
			}
		}
	}
};
</script>

<style></style>
